var map = {
	"./default-arrow.svg": 128,
	"./default-close.svg": 129,
	"./default-dot.svg": 130,
	"./default-minus.svg": 131,
	"./default-plus.svg": 132,
	"./social-media-facebook.svg": 133,
	"./social-media-googleplus.svg": 134,
	"./social-media-linkedin.svg": 135,
	"./social-media-mail.svg": 136,
	"./social-media-twitter.svg": 137,
	"./social-media-xing.svg": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;